import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

const LegalLayout = ({ children, title, lastUpdated }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-blue-500/30">
      {/* Background Decorative Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-600/10 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-600/10 blur-[120px] rounded-full" />
      </div>

      <div className="relative z-10 container mx-auto px-6 py-12 md:py-20 max-w-4xl">
        {/* Navigation / Header */}
        <button
          onClick={() => navigate(-1)}
          className="group flex items-center gap-2 text-gray-400 hover:text-white transition-all mb-12 bg-white/5 px-4 py-2 rounded-full border border-white/10 hover:bg-white/10"
        >
          <IoArrowBack className="group-hover:-translate-x-1 transition-transform" />
          <span className="text-sm font-bold">Go Back</span>
        </button>

        <header className="mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs font-bold text-gray-400 mb-6 uppercase tracking-widest">
            Legal Documentation
          </div>
          <h1 className="text-5xl md:text-7xl font-black mb-6 tracking-tight bg-gradient-to-r from-white via-white to-white/40 bg-clip-text text-transparent">
            {title}
          </h1>
          {lastUpdated && (
            <p className="text-gray-500 font-medium">
              Last updated: {lastUpdated}
            </p>
          )}
        </header>

        {/* Content Area */}
        <main className="prose prose-invert prose-blue max-w-none">
          <div className="bg-white/[0.02] border border-white/10 rounded-[2.5rem] p-8 md:p-16 backdrop-blur-xl shadow-2xl relative overflow-hidden">
             {/* Subtle internal glow */}
             <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" />
             
            <div className="relative z-10 space-y-8 text-gray-300 leading-relaxed text-lg">
              {children}
            </div>
          </div>
        </main>

        <footer className="mt-20 pt-12 border-t border-white/5 text-center text-gray-600 font-medium">
          <p>© {new Date().getFullYear()} Braccet Inc. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default LegalLayout;
